export default "__VITE_ASSET__CBj1iSXc__"